import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { IoChevronBack } from 'react-icons/io5';

const PrivacyPage = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <Header>
        <BackBtn onClick={() => navigate(-1)}><IoChevronBack size={24} /></BackBtn>
        <Title>개인정보 처리지침</Title>
      </Header>
      <Content>
        <Section>
          <H2>제1조 (개인정보의 처리 목적)</H2>
          <P>윤수빈 영어 연구소(이하 "연구소")는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.</P>
          <P>1. 회원 가입 및 관리: 회원 가입의사 확인, 본인 식별·인증, 회원자격 유지·관리</P>
          <P>2. 교육 서비스 제공: 수업 관리, 출석 관리, 과제·시험 성적 관리, 수업자료 제공</P>
          <P>3. 공지사항 및 메시지 전달</P>
        </Section>

        <Section>
          <H2>제2조 (수집하는 개인정보의 항목)</H2>
          <P>연구소는 서비스 제공을 위해 다음과 같은 개인정보를 수집합니다.</P>
          <P>1. 필수항목: 이름, 휴대전화번호, 이메일 주소, 비밀번호</P>
          <P>2. 선택항목: 프로필 사진</P>
          <P>3. 자동수집항목: 서비스 이용기록, 접속 로그, 접속 IP 정보</P>
        </Section>

        <Section>
          <H2>제3조 (개인정보의 처리 및 보유기간)</H2>
          <P>1. 연구소는 법령에 따른 개인정보 보유·이용기간 또는 이용자로부터 개인정보를 수집 시 동의받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.</P>
          <P>2. 회원 탈퇴 시 지체 없이 해당 개인정보를 파기합니다. 단, 관계 법령에 따라 보존할 필요가 있는 경우 해당 법령에서 정한 기간 동안 보관합니다.</P>
          <P>가. 계약 또는 청약철회 등에 관한 기록: 5년</P>
          <P>나. 대금결제 및 재화 등의 공급에 관한 기록: 5년</P>
          <P>다. 소비자의 불만 또는 분쟁처리에 관한 기록: 3년</P>
          <P>라. 접속 로그 기록: 3개월</P>
        </Section>

        <Section>
          <H2>제4조 (개인정보의 제3자 제공)</H2>
          <P>연구소는 이용자의 개인정보를 제1조에서 명시한 범위 내에서만 처리하며, 이용자의 동의 없이 제3자에게 개인정보를 제공하지 않습니다. 다만, 다음의 경우에는 예외로 합니다.</P>
          <P>1. 이용자가 사전에 동의한 경우</P>
          <P>2. 법령의 규정에 의하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우</P>
        </Section>

        <Section>
          <H2>제5조 (개인정보의 안전성 확보조치)</H2>
          <P>연구소는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.</P>
          <P>1. 개인정보의 암호화: 이용자의 비밀번호는 암호화되어 저장 및 관리됩니다.</P>
          <P>2. 접속기록의 보관: 개인정보 처리시스템에 접속한 기록을 최소 3개월 이상 보관합니다.</P>
          <P>3. 개인정보에 대한 접근 제한: 개인정보를 처리하는 직원을 최소한으로 제한하고 있습니다.</P>
        </Section>

        <Section>
          <H2>제6조 (이용자의 권리·의무 및 행사방법)</H2>
          <P>1. 이용자는 연구소에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.</P>
          <P>가. 개인정보 열람 요구</P>
          <P>나. 오류 등이 있을 경우 정정 요구</P>
          <P>다. 삭제 요구</P>
          <P>라. 처리정지 요구</P>
          <P>2. 위 권리 행사는 서면, 전자우편 등을 통하여 할 수 있으며 연구소는 이에 대해 지체 없이 조치하겠습니다.</P>
        </Section>

        <Section>
          <H2>제7조 (개인정보 보호책임자)</H2>
          <P>연구소는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 이용자의 불만처리 및 피해구제를 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.</P>
          <P>성명: 윤수빈</P>
          <P>직책: 대표</P>
          <P>연락처: kkan2222@gmail.com</P>
        </Section>

        <Footer>
          <FooterText>시행일: 2026년 2월 1일</FooterText>
        </Footer>
      </Content>
    </Container>
  );
};

export default PrivacyPage;

const Container = styled.div`
  background: white;
  min-height: 100vh;
  padding-bottom: 80px;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border-bottom: 1px solid #E5E7EB;
`;

const BackBtn = styled.button`
  color: #111;
`;

const Title = styled.p`
  font-size: 18px;
  font-weight: 600;
`;

const Content = styled.div`
  padding: 20px 16px;
`;

const Section = styled.div`
  margin-bottom: 24px;
`;

const H2 = styled.h2`
  font-size: 15px;
  font-weight: 700;
  color: #111;
  margin-bottom: 8px;
`;

const P = styled.p`
  font-size: 13px;
  color: #444;
  line-height: 1.8;
  word-break: keep-all;
`;

const Footer = styled.div`
  margin-top: 32px;
  padding-top: 16px;
  border-top: 1px solid #E5E7EB;
`;

const FooterText = styled.p`
  font-size: 12px;
  color: #999;
`;
